import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {
  ListConfiguredVendorsDto
} from "../../auto-generated-server-dtos/adjuster/configuration/list-configured-vendors-dto";

@Injectable({
  providedIn: 'root'
})
export class ListConfiguredVendorsService {

  constructor(private httpClient: HttpClient) { }

  listConfiguredVendors() {
    return this.httpClient.get<ListConfiguredVendorsDto[]>(`${environment.apiServer}/Adjuster/Configuration/ListConfiguredVendors`);
  }
}
